<template>
  <div>
    <!-- For Text -->
    {{ data.question }}
    <br />
    <div v-html="data.questionYoutubeLink" width="320" height="240"></div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      default: () => {}
    }
  }
};
</script>
